import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './base.css';
import { App } from './App.tsx';

const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('elemento #raiz nao existe no index.html');

createRoot(raiz).render(<StrictMode><App /></StrictMode>);
